<template>
  <v-container fluid style="height: 100%;">
    <v-row justify="space-around" class="ma-0">

      <!-- Equipo -->
      <v-col cols="12" lg="6" md="12">
        <v-row justify="space-around" class="subtitle3Text" style="font-weight: bolder;">{{ theNick }}</v-row>
        <v-row justify="space-around" class="subtitle4Text">{{ theMovilId }}</v-row>
        <v-row justify="space-around">
          <v-card style=" width: 100%;margin: 10px;" v-if="viewSkeletonsRL" :color="whitesmoke">
            <v-col cols="12">
              <div :class="skeletonRL" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div :class="skeletonColumnRL" :style="backgroundSkeleton + 'height: 170px !important;'"></div>
            </v-col>
          </v-card>

          <v-card style=" width: 100%;margin: 10px;" v-else>
            <v-progress-linear :active="loaderFuel" :indeterminate="loaderFuel" absolute top
              :color="colorTheme"></v-progress-linear>
            <v-icon :color="colorTheme" style="font-size: 65px;">mdi-tanker-truck</v-icon>
            <v-row justify="space-around" class="subtitle4Text" style="color: dimgray;margin-top:10px;">{{ $t("volume") }}</v-row>
            <v-row justify="space-around" style="font-size: xx-large;font-weight: bolder;">{{ lastLevel }}</v-row>
            <v-row justify="space-around" class="subtitle4Text" style="color: dimgray;">{{ dateLastLevel }}</v-row>
            <v-row justify="space-around" style="margin: 10px;">
            <span class="subtitle4Text text-decoration-underline" @click="openMap(lat1, lon1)" :style="`color: ${colorTheme}; cursor: pointer;`">
              {{addressLastLevel}}
            </span>
            </v-row>
            <v-row justify="space-around">
              <v-btn :color="colorTheme" class="white--text regularText" style="margin: 15px;" @click="updateLastLevel()">
                {{updateBtn}}
              </v-btn>
            </v-row>
          </v-card>

        </v-row>
      </v-col>

      <!-- Rendimiento -->
      <v-col cols="12" lg="6" md="12">
        <v-row justify="space-around">
          <v-card style=" width: 100%;margin: 10px;" :height="viewSkeletonsFP ? 255 : 276">
            <div style=" width: 100%;background-color: #CDCDCD;height: 35px;text-align: start; overflow: hidden;">
              <p class="subtitle2Text" style="padding: 4px;font-weight: bolder;float: left;cursor:auto !important;">{{
                $t("rendi") }}</p>
            </div>
            <template v-if="viewSkeletonsFP" :color="whitesmoke">
              <v-col cols="12" style="margin-top:20px;">
                <div :class="skeletonColumnFP" :style="backgroundSkeleton + 'height: 170px !important;'"></div>
              </v-col>
            </template>
            <template v-else>
              <v-icon :color="colorTheme" style="font-size: 60px;margin-top:10px;">mdi-chart-line</v-icon>
              <v-row justify="space-around" style="font-size: xx-large;font-weight: bolder;margin-top:10px;">{{ performanceAF }}</v-row>
              <v-row justify="space-around" class="regularText" style="color: dimgray;">{{ $t("effectivePeriod") }}, {{ $t("newFrom") }}: {{
                date1WS }}</v-row>
              <v-row justify="space-around" style="color: dimgray;">{{ $t("newTo") }}: {{ date2WS }}</v-row>
              <v-footer style="position: sticky; opacity: 0.6;background-color: #f5f5f500 !important;">
                <v-col class="text-right" cols="12" style="padding-bottom: 0;font-size: smaller;">* {{
                  $t("legendPerformance") }}</v-col>
              </v-footer>
            </template>
          </v-card>
        </v-row>
      </v-col>
    </v-row>

    <!-- Actividad reciente -->
    <v-row justify="space-around" style="padding-bottom: 135px;">
      <v-col cols="12">
        <v-card>
          <div style="width: 100%;background-color: #CDCDCD;height: 35px;text-align: start;">
            <p class="subtitle2Text" style="padding: 4px;font-weight: bolder;cursor:auto !important;">{{ $t("recentActivity")
              }}</p>
          </div>
          <template v-if="viewSkeletonsAR" :color="whitesmoke">
            <v-col cols="12" v-if="viewSkeletonsAR" :color="whitesmoke">
              <div :class="skeletonLineAR" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12" v-if="viewSkeletonsAR" :color="whitesmoke">
              <div :class="skeletonLineAR" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12" v-if="viewSkeletonsAR" :color="whitesmoke">
              <div :class="skeletonLineAR" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12" v-if="viewSkeletonsAR" :color="whitesmoke">
              <div :class="skeletonLineAR" :style="backgroundSkeleton"></div>
            </v-col>
          </template>
          <template v-for="(item, index) in dataFuel" v-else>
            <v-col cols="12" sm="12" v-bind:key="index">
              <div :class="checkType(item.Type)">
                <v-card>
                  <v-col cols="12" sm="12">
                    <v-row>
                      <v-col lg="1" sm="1" md="1" xs="1" cols="1" v-if="item.Type == 1">
                        <v-icon style="color: #74A036;font-size: 30px;">mdi-arrow-up-circle</v-icon>
                      </v-col>
                      <v-col lg="1" sm="1" md="1" xs="1" cols="1" v-else>
                        <v-icon style="color: #D53721;font-size: 30px;">mdi-arrow-down-circle</v-icon>
                      </v-col>
                      <v-col lg="10" sm="10" md="10" xs="10" cols="11">
                        <v-col cols="12" sm="12" style="padding:0;">
                          <p v-if="item.Type == 1" class="subtitle3Text"
                            style="text-align:start;width: 100%; margin: 0;font-weight: bold;cursor:auto !important;">
                            {{ item.Date }} {{ $t("load") }}</p>
                          <p v-else class="subtitle3Text"
                            style="text-align:start;width: 100%; margin: 0;font-weight: bold;cursor:auto !important;">
                            {{ item.Date }} {{ $t("discharge") }}</p>
                        </v-col>
                        <v-col cols="12" sm="12" class="text-start" style="padding:0;">
                          <span text class="subtitle4Text text-decoration-underline pa-0" :style="`color: ${colorTheme}; cursor: pointer;`"
                            @click="getReference(item)">{{ item.Location }}</span>
                        </v-col>
                        <v-col cols="12" sm="12" style="padding:0;">
                          <p class="subtitle4Text"
                            style="text-align:start;width: 100%;margin: 0;font-weight: bold;cursor:auto !important;">
                            {{ $t("magnitudeOfChange") }}:
                            <span :class="loadOrDischarge(item.Type)"> {{ item.VolumenChange }}</span>
                          </p>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
              </div>
            </v-col>
          </template>
          <v-row justify="space-around" v-if="viewSkeletonsAR == false">
            <v-btn style="margin: 15px;" :loading="loaderSeeMore" v-on:click="getMoreData()">{{$t("seeMore").toUpperCase() }}</v-btn>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "individualFuel",
  components: {
    calendarTime: () => import("@/components/calendarTime")
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Nick", value: "Nick" },
        { text: "Movil ID", value: "MovilId" }
      ],
      vehicles: [],
      showCalendar: false,
      showFilterV: false,
      selected: [],
      vehicleId: "",
      nick: "",
      loading3: false,
      loader: null
    };
  },
  created() {
    if (this.$store.state.visible == false) {
      this.$store.commit("bottomSheet");
    }
    this.$store.commit("setTitle", "ALERTFUEL");
    this.$store.commit("setPageHeader", ["ALERTFUEL", "", "", "", true]);

    var initialSettings = JSON.parse(localStorage.getItem("initialSettings"));
    if (!initialSettings) {
      this.$store.dispatch("getFuelVehicles");
    }

    this.$store.commit("updateBtn", this.$i18n.t("update"));
    var datesAF = JSON.parse(localStorage.getItem("PeriodTitleAF"));
    if (datesAF != undefined) {
      this.$store.commit("setPeriodTitleDates", datesAF);
    } else {
      var today = moment().format("YYYY-MM-DD");
      this.$store.commit("setPeriodTitleDates", [today]);
    }

    this.getAllData();
  },
  mounted() {
    this.$store.commit("selectionNames");
    this.$store.commit("backgroundSkeleton");
    var vehicle = localStorage.getItem("vehicleAF");
    vehicle = JSON.parse(vehicle);
    if (vehicle != undefined && vehicle != null) {
      var retrieveLevel = localStorage.getItem("setitemsRetrieveLevel");
      var itemsPerformance = localStorage.getItem("setitemsPerformanceAF");
      if (
        retrieveLevel != undefined &&
        retrieveLevel != null &&
        itemsPerformance != undefined &&
        itemsPerformance != null
      ) {
        this.$store.state.nickFromVehSelectedAF = vehicle.Nick;
        this.$store.state.movilIdFromVehSelectedAF = vehicle.MovilId;

      }
    }
  },
  watch: {},
  computed: {
    ...mapState([
      "itemsSettings",
      "colorTheme",
      "valueDeterminate",
      "calendarTime",
      "listVehiclesAF",
      "backgroundSkeleton",
      "viewSkeletonsFP",
      "viewSkeletonsAR",
      "viewSkeletonsRL",
      "itemsRetrieveLevel",
      "itemsPerformanceAF",
      "loaderFuel",
      "locationRG",
      "lastLevel",
      "dateLastLevel",
      "addressLastLevel",
      "lat1",
      "lon1",
      "performanceAF",
      "date1WS",
      "date2WS",
      "dataFuel",
      "loaderSeeMore",
      "updateBtn",
      //"disableBtnAFSM",
      "whitesmoke",
    ]),
    theNick: {
      get: function() {
        return this.$store.state.nickFromVehSelectedAF;
      }
    },
    theMovilId: {
      get: function() {
        return this.$store.state.movilIdFromVehSelectedAF;
      }
    },
    calendarTime: {
      get: function() {
        return this.$store.state.calendarTime;
      },
      set: function(val) {
        this.$store.commit("calendarTime", val);
      }
    },
    veh: {
      get: function() {
        return this.$store.state.vehicles;
      }
    },
    skeletonLineAR: {
      get: function() {
        return this.$store.state.skeletonLineAR;
      },
      set: function() {}
    },
    skeletonColumnFP: {
      get: function() {
        return this.$store.state.skeletonColumnFP;
      },
      set: function() {}
    },
    skeletonRL: {
      get: function() {
        return this.$store.state.skeletonRL;
      },
      set: function() {}
    },
    skeletonColumnRL: {
      get: function() {
        return this.$store.state.skeletonColumnRL;
      },
      set: function() {}
    }
  },
  methods: {
    checkType(theType) {
      if (theType == 2) {
        return "alerts-border";
      }
    },
    loadOrDischarge(type) {
      if (type == 1) {
        return "loadColor";
      } else {
        return "dischargeColor";
      }
    },
    getMoreData() {
      //this.$store.commit("viewSkeletonsFP", true);
      ////Si al usar el boton alcanzas el periodo de 2 meses se deshabilita boton ver mas
      // var items = JSON.parse(localStorage.getItem("setitemsPerformanceAF"));
      // var today = moment().format("YYYY-MM-DDTHH:mm");
      // today = moment(today, "YYYY-MM-DDTHH:mm");
      // var periodAllowed = 62;
      // var mostRecentAct, result;
      // items.ALERTFUEL_RECENT_ACTIVTY.forEach((el, index) => {
      //   mostRecentAct = moment(el.Date, "YYYY-MM-DDTHH:mm");
      //   result = today.diff(mostRecentAct, 'days');
      //   if (result > periodAllowed) {
      //     this.$store.commit("disableBtnAFSM", true);    
      //     return;      
      //   }
      // });
      // if (this.$store.state.disableBtnAFSM == false) {
      //   var vehicle = localStorage.getItem("vehicleAF");
      //   vehicle = JSON.parse(vehicle);
      //   this.$store.commit("cancelLoaderSeeMore", true);
      //   this.$store.dispatch("fuelPerformance", {
      //     vehicleId: vehicle.MovilId,
      //     showMore: true
      //   });
      //   this.$store.commit("snackbar", {
      //     snackbar: true,
      //     text: i18n.t("modifyPeriod"),
      //   });
      // } else {
      //   this.$store.commit("snackbar", {
      //     snackbar: true,
      //     text: i18n.t("noDataFP"),
      //   });
      // }
      var vehicle = localStorage.getItem("vehicleAF");
      vehicle = JSON.parse(vehicle);
      this.$store.commit("cancelLoaderSeeMore", true);
      this.$store.dispatch("fuelPerformance", {
        vehicleId: vehicle.MovilId,
        showMore: true
      });
    },
    getAllData() {
      var vehicle = localStorage.getItem("vehicleAF");
      var retrieveLevel = localStorage.getItem("setitemsRetrieveLevel");
      var itemsPerformance = localStorage.getItem("setitemsPerformanceAF");
      var loc = localStorage.getItem("setLocationRG");
      if (
        retrieveLevel != undefined &&
        retrieveLevel != null &&
        itemsPerformance != undefined &&
        itemsPerformance != null
      ) {
        //cuandos los 2 traen datos
        this.$store.commit("viewSkeletonsFP", false);
        this.$store.commit("viewSkeletonsAR", false);
        this.$store.commit("viewSkeletonsRL", false);
        retrieveLevel = JSON.parse(retrieveLevel);
        itemsPerformance = JSON.parse(itemsPerformance);
        if (itemsPerformance.ALERTFUEL_RECENT_ACTIVTY.length == 0) {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("noDataAR"),
          });
        }
        if (itemsPerformance.PERFORMANCE.length == 0) {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("noDataPerformance"),
          });
        }
        this.$store.dispatch("convertRetrieveLevel");
        this.$store.dispatch("convertPerformanceAF");

        this.$store.commit("setLocationRG", loc);
      } else if (
        retrieveLevel != undefined &&
        retrieveLevel != null &&
        (itemsPerformance == undefined || itemsPerformance == null)
      ) {
        //para cuando fuel perfomance no traiga datos y retrieve level si traiga datos
        this.$store.commit("viewSkeletonsRL", false);
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("noDataFP"),
        });
        this.$store.dispatch("setSkeletonsFP");
        this.$store.dispatch("setSkeletonsAR");
        retrieveLevel = JSON.parse(retrieveLevel);
        this.$store.dispatch("convertRetrieveLevel");
        this.$store.commit("setLocationRG", loc);
      } else if (
        (retrieveLevel == undefined || retrieveLevel == null) &&
        itemsPerformance != undefined &&
        itemsPerformance != null
      ) {
        //para cuando retrieve level no traiga datos y fuel performance si traiga datos
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("noDataRL")
        });
        this.$store.commit("viewSkeletonsFP", false);
        this.$store.commit("viewSkeletonsAR", false);
        this.$store.dispatch("setSkeletonsRL");
        itemsPerformance = JSON.parse(itemsPerformance);
        if (itemsPerformance.ALERTFUEL_RECENT_ACTIVTY.length == 0) {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("noDataAR"),
          });
        }
        if (itemsPerformance.PERFORMANCE.length == 0) {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("noDataPerformance"),
          });
        }
        this.$store.dispatch("convertPerformanceAF");
      } else {
        //cuando ninguno traiga datos
        this.$store.state.movilIdFromVehSelectedAF = i18n.t("noVehicle");
        this.$store.state.nickFromVehSelectedAF = "";
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("noData")
        });
        this.$store.dispatch("setSkeletonsFP");
        this.$store.dispatch("setSkeletonsAR");
        this.$store.dispatch("setSkeletonsRL");
      }
    },
    openMap(lat, lon) {
      let validateCoordinates = this.$store.getters.isValidLatLon({ lat: lat, lon: lon });
      if (validateCoordinates) {
        var url = "https://www.google.com/maps/?q=" + lat + "," + lon;
        window.open(url, "_blank");
      }
      else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("mapCoordinatesError")
        });
      }
    },
    vmenu() {
      this.showCalendar = false;
      this.showFilterV = false;
    },
    // getVehicleData(val) {
    //   this.showFilterV = false;
    //   var movilId = val[0].MovilId;
    //   this.vehicleId = val[0].MovilId;
    //   this.nick = val[0].Nick;
    //   this.$store.commit("viewSkeletonsFP", true);
    //   this.$store.commit("viewSkeletonsRL", true);
    //   localStorage.setItem("vehicleAF", JSON.stringify(val));
    //   this.$store.dispatch("lastLevelWS", { vehicleId: movilId });
    //   this.$store.dispatch("fuelPerformance", {
    //     vehicleId: movilId,
    //     showMore: false
    //   });
    // },
    showCalendarFunction() {
      this.$store.commit("calendarTime", true);
    },
    // showFilterVFunction() {
    //   this.$store.dispatch("getFuelVehicles");
    //   this.showFilterV = true;
    // },
    updateLastLevel() {
      if (this.$store.state.updateBtn == this.$i18n.t("update")) {
        var vehicle = localStorage.getItem("vehicleAF");
        vehicle = JSON.parse(vehicle);
        this.$store.commit("cancelLoader", true);
        this.$store.commit("updateBtn", this.$i18n.t("cancel"));
        this.$store.dispatch("lastLevelCommand", {
          vehicleId: vehicle.MovilId
        });
      } else {
        this.$store.commit("updateBtn", this.$i18n.t("update"));
        this.$store.commit("cancelLoader", false);
        this.$store.dispatch("cancelUpdateLevel");
      }
    },

    //Función para obtener referencia o mostrar ubicación en mapa
    async getReference(item) {
      if (item.Location == i18n.t("showReference")) {
        let reference = null;
        this.updateReferenceText(item, i18n.t("loadingLocation"));

        try {
          reference = await this.$store.dispatch("getReferenceData", item);
        } catch (e) {
          reference = null;
        }

        this.updateReferenceText(item, reference);

      } else {
        this.openMap(item.Lat, item.Lon);
      }
    },

    updateReferenceText(item, reference) {
      //como no tenemos IdReporte, se validará coincidencia con fecha, tipo y cambio de volumen
      let event = this.dataFuel.find(event => (event.DateTimestamp === item.DateTimestamp) && (event.Type === item.Type) && (event.VolumenChange === item.VolumenChange));
        if (event) {
          event.Location = reference || i18n.t("notAvailable");
        }
    }
  }
};
</script>

<style>
@import "./../assets/styles/skeletons.css";
.tableIndividualF.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.03);
}
.tableIndividualF.theme--dark.v-data-table tbody tr:nth-of-type(even) {
  background-color: rgba(0, 0, 0, 0.5);
}
.alerts-border {
  border-radius: 4px;
  border: 4px #ff0000 solid;
  animation: blink 1s infinite;
}
.loadColor {
  color: #74a036;
}
.dischargeColor {
  color: red;
}
@keyframes blink {
  50% {
    border-color: #fff;
  }
}
</style>
